import { useState } from 'react';
import LegalModal from './LegalModal';

export default function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | 'disclaimer' | null>(null);

  return (
    <>
      <footer className="bg-[#123524] pt-8 md:pt-12 pb-20 md:pb-6">
        <div className="section-padding">
          <div className="flex flex-col md:flex-row items-center md:items-start justify-between gap-5 md:gap-6 pb-7 md:pb-8 border-b border-white/10">
            <img
              src="https://storage.readdy-site.link/project_files/82b66968-cb22-42ee-9075-ece8509330fe/d7ebf39b-4e71-401b-976c-6b7206641a00_2522-removebg-preview.png?v=064e295420a590555ff0a1679155b011"
              alt="Confident Auriga"
              className="h-10 w-auto object-contain"
            />

            <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
              <a href="tel:+918861133745" className="flex items-center gap-2 text-white/60 hover:text-gold transition-colors duration-500">
                <i className="ri-phone-line text-gold text-sm"></i>
                <span className="font-body text-sm">+91 88611 33745</span>
              </a>
              <a href="https://wa.me/918861133745?text=Hi%2C%20I%27m%20interested%20in%20Confident%20Auriga.%20Please%20share%20more%20details." target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-white/60 hover:text-gold transition-colors duration-500">
                <i className="ri-whatsapp-line text-gold text-sm"></i>
                <span className="font-body text-sm">WhatsApp</span>
              </a>
              <a
                href="https://maps.app.goo.gl/4hfVwUuwC5W5ASWn6?g_st=ac"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-white/60 hover:text-gold transition-colors duration-500 hover:underline underline-offset-2"
              >
                <i className="ri-map-pin-line text-gold text-sm"></i>
                <span className="font-body text-sm">Thornahalli, Karnataka</span>
              </a>
            </div>
          </div>

          {/* Legal Links */}
          <div className="pt-4 md:pt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 mb-4 md:mb-5">
            <button
              onClick={() => setActiveModal('privacy')}
              className="font-body text-xs text-white/40 hover:text-gold transition-colors duration-500 tracking-wider"
            >
              Privacy Policy
            </button>
            <button
              onClick={() => setActiveModal('terms')}
              className="font-body text-xs text-white/40 hover:text-gold transition-colors duration-500 tracking-wider"
            >
              Terms & Conditions
            </button>
            <button
              onClick={() => setActiveModal('disclaimer')}
              className="font-body text-xs text-white/40 hover:text-gold transition-colors duration-500 tracking-wider"
            >
              Disclaimer
            </button>
          </div>

          <div className="pt-5 md:pt-6 flex flex-col sm:flex-row items-center justify-between gap-2 border-t border-white/10">
            <p className="font-body text-xs text-white/30 tracking-wider">
              &copy; 2026 Confident Auriga. All rights reserved.
            </p>
            <p className="font-body text-[10px] text-white/20 tracking-wider">
              WhatsApp enquiries preferred for fastest response
            </p>
          </div>
        </div>
      </footer>

      <LegalModal
        isOpen={!!activeModal}
        onClose={() => setActiveModal(null)}
        type={activeModal}
      />
    </>
  );
}